export default __webpack_public_path__ + "static/media/img-0262-saudi-arabia-full-face.a0ef3f64.png";